import styled, { css } from "styled-components"
import { up, down } from "styled-breakpoints"
import colors from "@constants/colors"
import { subtext } from "@constants/typography"
import { columns } from "@constants/layout"
import { IconWrapper } from "@components/icons/utils"

export const Container = styled.div`
  width: 100%;
  padding: 36px ${columns(4)};
  background-color: ${colors.snow};
`

export const Body = styled.div<{
  bgColor: string
}>`
  ${({ bgColor }) => css`
    display: block;
    font-family: "Jost", sans-serif;
    background-color: ${bgColor ? bgColor : `#000000`};

    ${down("tablet")} {
      background: rgb(0, 0, 0);
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      background: rgb(0, 0, 0);
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      padding: 30px 0;
    }
  `}

  button {
    background: #ff1c24;
    color: #fff;
    min-width: 150px;
    text-transform: uppercase;
    border: 0;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: 0.6s ease-out;

    ${down("tablet")} {
      width: 100%;
      padding: 15px;
    }

    &:hover {
      color: #ff1c24;
      background: #fff;
    }

    &:disabled {
      background: ${colors.mediumGray};
      cursor: not-allowed;
    }
  }
`

export const Content = styled.div`
  align-items: center;
  justify-content: space-between;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 16px;

  ${up("laptop")} {
    flex-direction: row;
    padding: 0;
  }

  ${down("tablet")} {
    padding: 10px 40px;
  }
`

export const Filters = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  ${up("laptop")} {
    flex-direction: row;
    padding: 0;
  }

  ${down("tablet")} {
    display: block;
    width: 100%;
  }
`

export const Filter = styled.div<{ disabled?: boolean }>`
  min-width: 150px;
  font-family: "Jost", sans-serif;
  flex-grow: 0;
  margin-right: 20px;

  ${down("tablet")} {
    margin-right: 0;
    margin-bottom: 10px;
  }

  ${({ disabled }) => css`
    pointer-events: ${disabled ? "none" : "all"};

    [class*="SelectInput__Container"] {
      background-color: ${disabled ? colors.mediumGray : colors.lightestGray};
    }
  `}

  [class*="SelectInput__Container"] {
    padding: 0 8px;
    height: 36px;

    ${down("tablet")} {
      height: 50px;
    }
  }

  [class*="MuiInput-formControl"] {
    margin-top: 16px;
    height: 16px;
    font-size: 14px;

    ${down("tablet")} {
      margin-top: 22px;
    }
  }

  [class*="MuiInputLabel-root"] {
    font-family: "Jost", sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    line-height: 16px;
    transform: translate(0, 10px) scale(1);

    ${down("tablet")} {
      transform: translate(0, 18px) scale(1);
    }
  }

  .MuiInputLabel-shrink {
    transform: translate(0, 4px) scale(0.6) !important;
  }

  .MuiNativeSelect-icon {
    top: 0px;
  }
`

export const Label = styled.div<{
  fontColor: string
}>`
  ${({ fontColor }) => css`
    color: ${fontColor ? fontColor : `#ffffff`};
    margin-bottom: 15px;
    text-transform: uppercase;
    font-family: "Jost", sans-serif;

    ${down("tablet")} {
      margin-bottom: 0;
      text-shadow: 0 0 10px black;
    }

    > div {
      font-size: 15px;

      ${down("tablet")} {
        text-align: center;
        font-size: 20px;
        font-weight: 600;
      }
    }

    > h1 {
      font-size: 25px;
      line-height: 25px;
      font-weight: 400;
      margin: 0;

      ${down("tablet")} {
        display: none;
      }
    }
  `}
`

export const Footer = styled.div`
  ${subtext}
  font-weight: normal;
  align-items: center;
  justify-content: start;
  display: flex;
  color: ${colors.slateDark};

  ${IconWrapper} {
    opacity: 0.4;
    width: 20px;
    height: 20px;
    margin-right: 20px;
    border: 1.5px solid ${colors.slateLight};
    border-radius: 50%;
  }
`
